import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginDialog: false
  },
  getters: {
    loginDialog: state => state.loginDialog
  },
  mutations: {
    toggleLoginDialog (state, payload) {
      state.loginDialog = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
